<div class="gw-space-y-6">
  <h3 class="gw-text-lg gw-font-semibold gw-text-text-primary">
    {{ 'features.domains.settings.page.sectionTitle' | translate }}
  </h3>

  <div>
    <!-- Title -->
    <div class="gw-mb-6">
      <gatewee-input-v2
        [form]="internalFormGroup"
        controlName="title"
        id="page-title"
        label="features.domains.settings.page.title"
        [placeholder]="
          'features.domains.settings.page.titlePlaceholder' | translate
        "
        type="text"
        [required]="true"
      ></gatewee-input-v2>
    </div>

    <!-- Description -->
    <div class="gw-mb-6">
      <gatewee-input-v2
        [form]="internalFormGroup"
        controlName="description"
        id="page-description"
        label="features.domains.settings.page.description"
        [placeholder]="
          'features.domains.settings.page.descriptionPlaceholder' | translate
        "
        type="text"
      ></gatewee-input-v2>
    </div>

    <!-- Keywords -->
    <div class="gw-mb-6">
      <gatewee-input-v2
        [form]="internalFormGroup"
        controlName="keywords"
        id="page-keywords"
        label="features.domains.settings.page.keywords"
        [placeholder]="
          'features.domains.settings.page.keywordsPlaceholder' | translate
        "
        type="text"
      ></gatewee-input-v2>
    </div>

    <!-- Google Analytics ID -->
    <div class="gw-mb-6">
      <gatewee-input-v2
        [form]="internalFormGroup"
        controlName="googleAnalyticsId"
        id="google-analytics-id"
        label="features.domains.settings.page.googleAnalyticsId"
        [placeholder]="
          'features.domains.settings.page.googleAnalyticsIdPlaceholder'
            | translate
        "
        type="text"
      ></gatewee-input-v2>
    </div>

    <!-- Support Contact Fields -->
    <div class="gw-grid gw-grid-cols-1 md:gw-grid-cols-2 gw-gap-4 gw-mb-6">
      <!-- Support Contact Email -->
      <gatewee-input-v2
        [form]="internalFormGroup"
        controlName="supportContactEmail"
        id="support-contact-email"
        label="features.domains.settings.page.supportContactEmail"
        [placeholder]="
          'features.domains.settings.page.supportContactEmailPlaceholder'
            | translate
        "
        type="email"
      ></gatewee-input-v2>

      <!-- Support Contact WhatsApp -->
      <gatewee-input-v2
        [form]="internalFormGroup"
        controlName="supportContactWhatsapp"
        id="support-contact-whatsapp"
        label="features.domains.settings.page.supportContactWhatsapp"
        [placeholder]="
          'features.domains.settings.page.supportContactWhatsappPlaceholder'
            | translate
        "
        type="text"
      ></gatewee-input-v2>
    </div>

    <!-- Institutional Website URL -->
    <div class="gw-mb-6">
      <gatewee-input-v2
        [form]="internalFormGroup"
        controlName="institutionalWebsiteURL"
        id="institutional-website-url"
        label="features.domains.settings.page.institutionalWebsiteURL"
        [placeholder]="
          'features.domains.settings.page.institutionalWebsiteURLPlaceholder'
            | translate
        "
        type="text"
      ></gatewee-input-v2>
    </div>

    <!-- Mobile: Hero -->
    <div class="gw-mt-8 gw-pt-6 gw-border-t gw-border-border-normal">
      <h4 class="gw-text-base gw-font-semibold gw-text-text-primary gw-mb-4">
        {{ 'features.domains.settings.page.mobileSectionTitle' | translate }}
      </h4>
      <div class="gw-space-y-4">
        <div class="gw-mb-6">
          <gatewee-input-v2
            [form]="mobileHeroFormGroup"
            controlName="title"
            id="page-mobile-hero-title"
            label="features.domains.settings.page.mobileHeroTitle"
            [placeholder]="
              'features.domains.settings.page.mobileHeroTitlePlaceholder'
                | translate
            "
            type="text"
          ></gatewee-input-v2>
        </div>
        <div class="gw-mb-6">
          <gatewee-input-v2
            [form]="mobileHeroFormGroup"
            controlName="description"
            id="page-mobile-hero-description"
            label="features.domains.settings.page.mobileHeroDescription"
            [placeholder]="
              'features.domains.settings.page.mobileHeroDescriptionPlaceholder'
                | translate
            "
            type="text"
          ></gatewee-input-v2>
        </div>
        <div class="gw-mb-6">
          <gatewee-asset-upload
            [control]="mobileHeroImageControl"
            assetType="contentImage"
            [domainId]="domainId"
            [aspectRatio]="1"
            [resizeToWidth]="1200"
            [resizeToHeight]="1280"
            [label]="
              'features.domains.settings.page.mobileHeroImage' | translate
            "
          ></gatewee-asset-upload>
        </div>
      </div>
    </div>

    <!-- Onboarding -->
    <div class="gw-mt-8 gw-pt-6 gw-border-t gw-border-border-normal">
      <h4 class="gw-text-base gw-font-semibold gw-text-text-primary gw-mb-4">
        {{
          'features.domains.settings.page.onboardingSectionTitle' | translate
        }}
      </h4>
      <div class="gw-space-y-4">
        <div class="gw-mb-6">
          <gatewee-input-v2
            [form]="onboardingFormGroup"
            controlName="title"
            id="page-onboarding-title"
            label="features.domains.settings.page.onboardingTitle"
            [placeholder]="
              'features.domains.settings.page.onboardingTitlePlaceholder'
                | translate
            "
            type="text"
          ></gatewee-input-v2>
        </div>
        <div class="gw-mb-6">
          <gatewee-input-v2
            [form]="onboardingFormGroup"
            controlName="description"
            id="page-onboarding-description"
            label="features.domains.settings.page.onboardingDescription"
            [placeholder]="
              'features.domains.settings.page.onboardingDescriptionPlaceholder'
                | translate
            "
            type="text"
          ></gatewee-input-v2>
        </div>
      </div>
    </div>

    <!-- Onboarding side panel -->
    <div class="gw-mt-8 gw-pt-6 gw-border-t gw-border-border-normal">
      <h4 class="gw-text-base gw-font-semibold gw-text-text-primary gw-mb-4">
        {{ 'features.domains.settings.page.sidePanelSectionTitle' | translate }}
      </h4>
      <div class="gw-space-y-4">
        <div class="gw-mb-6">
          <gatewee-input-v2
            [form]="onboardingSidePanelFormGroup"
            controlName="headerTitle"
            id="page-side-panel-header-title"
            label="features.domains.settings.page.sidePanelHeaderTitle"
            [placeholder]="
              'features.domains.settings.page.sidePanelHeaderTitlePlaceholder'
                | translate
            "
            type="text"
          ></gatewee-input-v2>
        </div>
        <div class="gw-mb-6">
          <gatewee-input-v2
            [form]="onboardingSidePanelFormGroup"
            controlName="footerTitle"
            id="page-side-panel-footer-title"
            label="features.domains.settings.page.sidePanelFooterTitle"
            [placeholder]="
              'features.domains.settings.page.sidePanelFooterTitlePlaceholder'
                | translate
            "
            type="text"
          ></gatewee-input-v2>
        </div>
        <div class="gw-mb-6">
          <gatewee-input-v2
            [form]="onboardingSidePanelFormGroup"
            controlName="footerDescription"
            id="page-side-panel-footer-description"
            label="features.domains.settings.page.sidePanelFooterDescription"
            [placeholder]="
              'features.domains.settings.page.sidePanelFooterDescriptionPlaceholder'
                | translate
            "
            type="text"
          ></gatewee-input-v2>
        </div>
        <div class="gw-mb-6">
          <gatewee-asset-upload
            [control]="sidePanelBackgroundImageControl"
            assetType="contentImage"
            [domainId]="domainId"
            [aspectRatio]="16 / 9"
            [resizeToWidth]="1920"
            [resizeToHeight]="1080"
            [label]="
              'features.domains.settings.page.sidePanelBackgroundImage'
                | translate
            "
          ></gatewee-asset-upload>
        </div>
      </div>
    </div>

    <!-- Login page (monolith) -->
    <div class="gw-mt-8 gw-pt-6 gw-border-t gw-border-border-normal">
      <h4 class="gw-text-base gw-font-semibold gw-text-text-primary gw-mb-4">
        {{ 'features.domains.settings.page.loginSectionTitle' | translate }}
      </h4>
      <p class="gw-mb-4 gw-text-sm gw-text-text-secondary">
        {{
          'features.domains.settings.page.loginSectionDescription' | translate
        }}
      </p>
      <div class="gw-space-y-4">
        <div class="gw-mb-6">
          <gatewee-asset-upload
            [control]="loginSidePanelBackgroundImageControl"
            assetType="contentImage"
            [domainId]="domainId"
            [aspectRatio]="3 / 4"
            [resizeToWidth]="1080"
            [resizeToHeight]="1440"
            [label]="
              'features.domains.settings.page.loginSidePanelBackgroundImage'
                | translate
            "
          ></gatewee-asset-upload>
          <p class="gw-mt-2 gw-text-xs gw-text-text-tertiary">
            {{
              'features.domains.settings.page.loginSidePanelImageSpec'
                | translate
            }}
          </p>
        </div>

        <div class="gw-mb-6">
          <label
            class="gw-mb-2 gw-block gw-text-sm gw-font-medium gw-text-text-primary"
            for="page-login-headline"
          >
            {{ 'features.domains.settings.page.loginHeadline' | translate }}
          </label>
          <p class="gw-mb-2 gw-text-xs gw-text-text-tertiary">
            {{ 'features.domains.settings.page.loginHeadlineHint' | translate }}
          </p>
          <textarea
            id="page-login-headline"
            [formControl]="loginSidePanelHeadlineControl"
            rows="6"
            class="gw-box-border gw-min-h-[120px] gw-w-full gw-resize-y gw-rounded-lg gw-border gw-border-border-normal gw-bg-background-base gw-p-medium gw-font-mono gw-text-sm gw-text-text-primary placeholder:gw-text-text-tertiary focus:gw-border-brand-primary focus:gw-outline-none"
            [placeholder]="
              'features.domains.settings.page.loginHeadlinePlaceholder'
                | translate
            "
          ></textarea>
        </div>

        <div class="gw-mb-6">
          <gatewee-input-v2
            [form]="loginSidePanelFormGroup"
            controlName="subheadline"
            id="page-login-subheadline"
            label="features.domains.settings.page.loginSubheadline"
            [placeholder]="
              'features.domains.settings.page.loginSubheadlinePlaceholder'
                | translate
            "
            type="text"
          ></gatewee-input-v2>
        </div>

        <div class="gw-mb-6">
          <div
            class="gw-mb-3 gw-flex gw-flex-wrap gw-items-center gw-justify-between gw-gap-3"
          >
            <span class="gw-text-sm gw-font-medium gw-text-text-primary">
              {{
                'features.domains.settings.page.loginStatsSection' | translate
              }}
            </span>
            <gatewee-button
              variant="secondary"
              size="s"
              type="button"
              [title]="
                'features.domains.settings.page.loginStatAddRow' | translate
              "
              (clicked)="addLoginStatRow()"
            ></gatewee-button>
          </div>
          <div class="gw-space-y-4">
            <div
              *ngFor="
                let statGroup of loginStatsFormArray.controls;
                let i = index
              "
              class="gw-flex gw-flex-col gw-gap-3 gw-rounded-lg gw-border gw-border-border-normal gw-bg-background-elevation-1 gw-p-medium md:gw-flex-row md:gw-items-end"
              [formGroup]="$any(statGroup)"
            >
              <div class="gw-flex-1">
                <gatewee-input-v2
                  [form]="$any(statGroup)"
                  controlName="value"
                  [id]="'page-login-stat-value-' + i"
                  label="features.domains.settings.page.loginStatValue"
                  [placeholder]="
                    'features.domains.settings.page.loginStatValuePlaceholder'
                      | translate
                  "
                  type="text"
                ></gatewee-input-v2>
              </div>
              <div class="gw-flex-1">
                <gatewee-input-v2
                  [form]="$any(statGroup)"
                  controlName="label"
                  [id]="'page-login-stat-label-' + i"
                  label="features.domains.settings.page.loginStatLabel"
                  [placeholder]="
                    'features.domains.settings.page.loginStatLabelPlaceholder'
                      | translate
                  "
                  type="text"
                ></gatewee-input-v2>
              </div>
              <gatewee-button
                variant="outline"
                size="s"
                type="button"
                [title]="
                  'features.domains.settings.page.loginStatRemoveRow'
                    | translate
                "
                (clicked)="removeLoginStatRow(i)"
              ></gatewee-button>
            </div>
          </div>
        </div>

        <div
          class="gw-grid gw-grid-cols-1 gw-gap-4 gw-border-t gw-border-border-soft gw-pt-6 md:gw-grid-cols-2"
        >
          <gatewee-input-v2
            [form]="loginMobileAppFormGroup"
            controlName="appStoreUrl"
            id="page-login-app-store-url"
            label="features.domains.settings.page.loginAppStoreUrl"
            [placeholder]="
              'features.domains.settings.page.loginAppStoreUrlPlaceholder'
                | translate
            "
            type="text"
          ></gatewee-input-v2>
          <gatewee-input-v2
            [form]="loginMobileAppFormGroup"
            controlName="googlePlayUrl"
            id="page-login-google-play-url"
            label="features.domains.settings.page.loginGooglePlayUrl"
            [placeholder]="
              'features.domains.settings.page.loginGooglePlayUrlPlaceholder'
                | translate
            "
            type="text"
          ></gatewee-input-v2>
        </div>
      </div>
    </div>

    <!-- Site footer -->
    <div class="gw-mt-8 gw-pt-6 gw-border-t gw-border-border-normal">
      <h4 class="gw-text-base gw-font-semibold gw-text-text-primary gw-mb-4">
        {{ 'features.domains.settings.page.footerSectionTitle' | translate }}
      </h4>
      <div class="gw-mb-6">
        <gatewee-input-v2
          [form]="footerFormGroup"
          controlName="copyright"
          id="page-footer-copyright"
          label="features.domains.settings.page.footerCopyright"
          [placeholder]="
            'features.domains.settings.page.footerCopyrightPlaceholder'
              | translate
          "
          type="text"
        ></gatewee-input-v2>
      </div>
    </div>

    <!-- Checkout footer -->
    <div class="gw-mt-8 gw-pt-6 gw-border-t gw-border-border-normal">
      <h4 class="gw-text-base gw-font-semibold gw-text-text-primary gw-mb-4">
        {{
          'features.domains.settings.page.checkoutFooterSectionTitle'
            | translate
        }}
      </h4>
      <div class="gw-space-y-4">
        <div class="gw-mb-6">
          <gatewee-input-v2
            [form]="checkoutFooterFormGroup"
            controlName="disclaimer"
            id="page-checkout-footer-disclaimer"
            label="features.domains.settings.page.checkoutFooterDisclaimer"
            [placeholder]="
              'features.domains.settings.page.checkoutFooterDisclaimerPlaceholder'
                | translate
            "
            type="text"
          ></gatewee-input-v2>
        </div>
        <div class="gw-mb-6">
          <gatewee-input-v2
            [form]="checkoutFooterFormGroup"
            controlName="copyright"
            id="page-checkout-footer-copyright"
            label="features.domains.settings.page.checkoutFooterCopyright"
            [placeholder]="
              'features.domains.settings.page.checkoutFooterCopyrightPlaceholder'
                | translate
            "
            type="text"
          ></gatewee-input-v2>
        </div>
      </div>
    </div>

    <!-- Legal documents (PDF) -->
    <div class="gw-mt-8 gw-pt-6 gw-border-t gw-border-border-normal">
      <h4 class="gw-text-base gw-font-semibold gw-text-text-primary gw-mb-4">
        {{ 'features.domains.settings.page.assetsSectionTitle' | translate }}
      </h4>
      <div class="gw-space-y-4">
        <div class="gw-mb-6">
          <gatewee-asset-upload
            [control]="assetsTermsOfServiceControl"
            assetType="docsPdf"
            [domainId]="domainId"
            [label]="
              'features.domains.settings.page.termsOfService' | translate
            "
          ></gatewee-asset-upload>
        </div>
        <div class="gw-mb-6">
          <gatewee-asset-upload
            [control]="assetsPrivacyPolicyControl"
            assetType="docsPdf"
            [domainId]="domainId"
            [label]="'features.domains.settings.page.privacyPolicy' | translate"
          ></gatewee-asset-upload>
        </div>
      </div>
    </div>
  </div>
</div>
